module.exports = __webpack_public_path__ + "static/WEDDING E&M-384-df1b092c4718f521a710b0df13b96620.jpg";